import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignaturePadComponent } from './signature-pad.component';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from '@progress/kendo-angular-buttons';

@NgModule({
  declarations: [SignaturePadComponent],
  imports: [
    CommonModule,
    ButtonModule,
    TranslateModule
  ],
  exports: [SignaturePadComponent],
})
export class SignaturePadModule { }
